export default "__VITE_ASSET__7dc1dee0__"